import { addRasterOverlay, removeRasterOverlay } from '../raster_helpers';

const weatherId = 'weather';

const addWeather = map => {
  /*
   * Weather tiles are served through a Cloudfront Distribution, which can be access by the subdomain weather-radar.alltrails.com.
   * The Cloudfront distribution redirects the request to the internal AllTrails API,
   * which uses Ngnix reverse-proxy to send the final request to the Weather Channel API.
   *
   * The tiles are cached for 15 minutes by CloudFront
   * based on the timestamp (in 15 minute increments) and the X,Y,Z coordinates requested in the query string.
   *
   * Cloudfront Distribution:
   *  - Origin: api-v5.alltrails.com/tiles/v4/radarSatellite
   *  - Cache:
   *     - Query string:
   *        - ts
   *        - fts
   *        - xyz
   *     - TTL: 15 minutes
   *  - Configurations: https://us-east-1.console.aws.amazon.com/cloudfront/v3/home?region=us-west-2#/distributions/E115DZ1OVR175S
   *
   * Route53:
   *  - Configurations: https://us-east-1.console.aws.amazon.com/route53/v2/hostedzones?region=us-east-1#ListRecordSets/Z2KA02DV082R8Y
   *
   * Ngnix:
   *  - Configurations: https://github.com/alltrails/alltrails-nginx/blob/alpha/templates/map_layers_overlays.conf#L443
   */

  // url
  const baseUrl = 'https://weather-radar.alltrails.com';

  // query params
  const date = new Date().getTime();
  const fifteenMin = 1000 * 60 * 15;
  const fifteenFloorTimestamp = new Date(Math.floor(date / fifteenMin) * fifteenMin).getTime() / 1000;
  const fifteenCeilTimestamp = new Date(Math.ceil(date / fifteenMin) * fifteenMin).getTime() / 1000;

  addRasterOverlay(
    map,
    weatherId,
    `${baseUrl}?ts=${fifteenFloorTimestamp}&fts=${fifteenCeilTimestamp}&xyz={x}:{y}:{z}`, // apiKey added by Ngnix reverse-proxy
    {
      attribution: "<a target='_blank' href='https://www.weather.com/'>Weather.com</a>",
      tileSize: 256
    },
    {
      paint: {
        'raster-opacity': 0.5
      }
    }
  );
};

const removeWeather = map => {
  removeRasterOverlay(map, weatherId);
};

export { addWeather, removeWeather };
